export default "__VITE_ASSET__DJcawxgA__"